module.exports = __webpack_public_path__ + "img/download_pc.4bcf78a8.png";